import React from 'react';
import { Box } from '@mui/material';
import * as styles from './styles';

function StatusPill({ isActive }) {
    return (
        <Box sx={isActive ? styles.active : styles.inactive}>
            {isActive ? 'Active' : 'Inactive'}
        </Box>
    );
}

export default StatusPill;
